export const apiBaseUrl = process.env.REACT_APP_BASE_URL;
export const staticUrl = process.env.REACT_APP_BASE_STATIC;
export const TinyMCKEY = process.env.REACT_APP_BASE_TINYMC_KEY;
export const baseUrl = process.env.REACT_APP_BASE;
